import { useQuery } from '@tanstack/react-query';
import { api } from '@/services/api-client';

/**
 * Signing in to the API: finds or creates the account and answers with it.
 * Idempotent, so it is read like a query, once per visit, and its answer is
 * the signed-in account for as long as the visit lasts.
 */
export function signInOptions() {
  return {
    ...api.queryOptions('post', '/me/sign-in'),
    staleTime: 'static' as const,
  };
}

/** The signed-in account. */
export function useMe() {
  return useQuery(signInOptions());
}
